var exports = {
  "i": "xaee3c4fa--ef0faf--wrapper",
};

module.exports = exports;
